export default __webpack_public_path__ + "static/media/event-action-notification.5fd98991.svg";